import {
  useMostAccessedCatalogsSource,
  UseMostAccessedCatalogsSourceParams,
} from './most-accessed-catalogs-source';

export const useMostAccessedCatalogsByDescriptionSource = (
  params: UseMostAccessedCatalogsSourceParams,
  options?: { enabled?: boolean }
) => useMostAccessedCatalogsSource('description', params, options);
